export class RetailRocket {
    track(callback) {
        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
            try {
                callback();
            } catch (e) {
                if (isDevelopment) {
                    console.log(e);
                }
            }
        });
    }

    viewContentProduct(product) {
        if (!product) {
            return;
        }

        let callback;
        if (product.is_offers) {
            callback = function() {
                rrApi.groupView(product.offers_id);
            };
        } else {
            callback = function() {
                rrApi.view(product.id);
            };
        }

        this.track(callback);
    }

    viewContentCategory(category) {
        if (!category) {
            return;
        }

        this.track(function() {
            rrApi.categoryView(category.id);
        });
    }

    setProfile(params) {
        if (!params) {
            return;
        }

        this.track(function() {
            rrApi.setProfile(params);
        });
    }
    setCustomer(user) {
        if (!user.authorized) {
            return;
        }

        let phone = '7' + user['phone'];
        if (user.phone_format) {
            phone = user.phone_format;
        }

        this.track(function() {
            rrApi.setCustomer({
                customerId: user['user_id'],
                email: user['email'],
                phone: phone
            });
        });
    }

    search() {
        this.track(function() {
            rrApi.search('search_phrase');
        });
    }

    /*
    subscription(email) {
        this.track(function() {
            rrApi.setEmail(email);
            rrApi.welcomeSequence(email);
        });
    }
  
    subscriptionPopup(email) {
        this.track(function() {
            rrApi.setEmail(email, {EmailPopUp: true});
            rrApi.welcomeSequence(email);
        });
    }
  
    oneClick(productId) {
        this.track(function() {
            rrApi.addToBasket(productId);
        });
    }
    */

    addToCart(product) {
        this.track(function() {
            rrApi.addToBasket(product.id);
        });
    }

    orderTransaction(order, basket) {
        let params = {
            transaction: order.id,
            items: this.formatBasket(basket)
        };
        this.track(function() {
            rrApi.order(params);
        });
    }

    /*
    productAddToFavorite(params) {
        this.track(function() {
            rrApi.subscribeonpricedrop(params.email, [params.product]);
        });
    }
    */

    formatBasket(basket) {
        return basket.map(basketItem => {
            return RetailRocket.formatBasketItem(basketItem);
        });
    }

    static formatBasketItem(basketItem) {
        return {
            id: basketItem.offer_id || basketItem.id,
            qnt: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price)
        };
    }
}



// WEBPACK FOOTER //
// ./modules/tracker/retailrocket.js